import { Observable } from 'rxjs/Observable';
import { ConteudoModel } from './../../model/caixa/conteudo.model';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Injectable } from '@angular/core';
import GenericReturn from 'app/model/generic/generic-return.model';

@Injectable()
export class ConteudoService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  incluirItens(caixaId: number, conteudo: ConteudoModel): Observable<ConteudoModel> {
    return this.httpClient.post<ConteudoModel>(this.apiURL + `/incluir-conteudo/${caixaId}`, conteudo, this.httpOptions);
  }

  listaItens(caixaId: number): Observable<Array<ConteudoModel>> {
    return this.httpClient.get<Array<ConteudoModel>>(this.apiURL + `/listar-conteudo/${caixaId}`, this.httpOptions);
  }

  listaItensRelatorio(caixaId: number): Observable<Array<ConteudoModel>> {
    return this.httpClient.get<Array<ConteudoModel>>(this.apiURL + `/listar-conteudo-relatorio/${caixaId}`, this.httpOptions);
  }

  apagarItem(caixaId: number, conteudoId: number) {
    const headers = new HttpHeaders()
    .set('ticket', sessionStorage.getItem('ticket-ECM'))
    .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.delete(this.apiURL + `/apagar-conteudo/${caixaId}/${conteudoId}`, { headers, responseType: 'text' });
  }

  getConteudosIdCliente(idCliente: number): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(this.apiURL + `/listar-conteudos/${idCliente}`, this.httpOptions);
  }

  editarItem(conteudo: ConteudoModel) {
    return this.httpClient.put(this.apiURL + '/editar-conteudo', conteudo, this.httpOptions);
  }

  pesquisaAvancadaConteudo(clienteId: number, pesquisaConteudo: Array<any>): Observable<Array<any>> {
    return this.httpClient.post<Array<any>>(this.apiURL + `/pesquisa-avancada-conteudo/${clienteId}`, pesquisaConteudo, this.httpOptions);
  }

  buscarConteudoEmConsulta(caixaId: number): Observable<GenericReturn<any>> {
    return this.httpClient.get<GenericReturn<any>>(this.apiURL + `/buscar-conteudo-em-consulta/${caixaId}`, this.httpOptions);
  }

  buscarConteudoEmCustodia(caixaId: number): Observable<GenericReturn<any>> {
    return this.httpClient.get<GenericReturn<any>>(this.apiURL + `/buscar-conteudo-em-custodia/${caixaId}`, this.httpOptions);
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/caixa/conteudo.service.ts